var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIssue1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.875 28.4813V62.55C66.875 62.9 66.5938 63.175 66.25 63.175H13.75C13.4062 63.175 13.125 62.9 13.125 62.55V28.4813C13.125 26.7375 14.5437 25.3125 16.2937 25.3125H63.7062C65.4562 25.3125 66.875 26.7375 66.875 28.4813Z",
    fill: "#D0FAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8734 28.4813V62.55C66.8734 62.9 66.5922 63.175 66.2484 63.175H44.6797C59.6109 57.35 63.0609 45.925 61.2484 36.25C60.4422 31.9438 58.0234 27.5688 56.6422 25.3125H63.7047C65.4547 25.3125 66.8734 26.7375 66.8734 28.4813Z",
    fill: "#ACDEE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4023 47.9062H58.8355",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.643 28.4625V31.1687C66.643 31.5125 66.3617 31.7937 66.018 31.7937H14.2305C13.8867 31.7937 13.6055 31.5125 13.6055 31.1687V28.4625C13.6055 26.725 15.018 25.3125 16.7555 25.3125H63.4867C65.2242 25.3125 66.643 26.725 66.643 28.4625Z",
    fill: "#EE4C7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6445 28.4625V31.1687C66.6445 31.5125 66.3633 31.7937 66.0195 31.7937H59.9195C58.8758 29.1375 57.5445 26.7812 56.6445 25.3125H63.4883C65.2258 25.3125 66.6445 26.725 66.6445 28.4625Z",
    fill: "#B22D59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4023 41.6138H57.6911L61.1236 37.6094",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1044 47.9062H20.6719",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9556 33.6027C41.0616 33.6027 41.9581 32.7061 41.9581 31.6002C41.9581 30.4942 41.0616 29.5977 39.9556 29.5977C38.8497 29.5977 37.9531 30.4942 37.9531 31.6002C37.9531 32.7061 38.8497 33.6027 39.9556 33.6027Z",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4023 53.627H57.6911L61.1236 57.6313",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1041 41.6138H21.8159L18.3828 37.6094",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.957 33.6035V37.3066",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5111 29.153C17.0548 29.153 16.6836 28.7818 16.6836 28.3255C16.6836 27.8693 17.0548 27.498 17.5111 27.498C17.9673 27.498 18.3386 27.8693 18.3386 28.3255C18.3386 28.7818 17.9673 29.153 17.5111 29.153Z",
    fill: "#FF83C7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0266 40.0055V53.518C56.0266 55.1805 54.6703 56.5367 53.0016 56.5367H26.9078C25.2391 56.5367 23.8828 55.1805 23.8828 53.518V40.0055C23.8828 38.3367 25.2391 36.9805 26.9078 36.9805H53.0016C54.6703 36.9805 56.0266 38.3367 56.0266 40.0055Z",
    fill: "#FFBD5B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1041 53.627H21.8159L18.3828 57.6313",
    stroke: "#00D3D3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7806 29.153C20.3244 29.153 19.9531 28.7818 19.9531 28.3255C19.9531 27.8693 20.3244 27.498 20.7806 27.498C21.2369 27.498 21.6081 27.8693 21.6081 28.3255C21.6088 28.7818 21.2369 29.153 20.7806 29.153Z",
    fill: "#FFBD5B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0541 29.153C23.5978 29.153 23.2266 28.7818 23.2266 28.3255C23.2266 27.8693 23.5978 27.498 24.0541 27.498C24.5103 27.498 24.8816 27.8693 24.8816 28.3255C24.8822 28.7818 24.5103 29.153 24.0541 29.153Z",
    fill: "#00E77B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0266 49.7695V53.5195C56.0266 55.182 54.6703 56.5383 53.0016 56.5383H26.9078C25.2391 56.5383 23.8828 55.182 23.8828 53.5195V49.7695C23.8828 51.432 25.2391 52.7883 26.9078 52.7883H53.0016C54.6703 52.7883 56.0266 51.432 56.0266 49.7695Z",
    fill: "#FF7B5B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7216 28.2266H59.2891",
    stroke: "#760044",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6072 37.6875L41.9103 49.3844C40.9816 50.3131 39.4853 50.3456 38.5178 49.4575L26.2266 38.1794",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6562 54.7711L35.3819 46.7617",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8311 54.7711L45.1055 46.7617",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7491 47.9061C61.7491 46.9298 60.9553 46.1367 59.9803 46.1367C59.0041 46.1367 58.2109 46.9305 58.2109 47.9061C58.2109 48.8817 59.0047 49.6755 59.9803 49.6755C60.9553 49.6755 61.7491 48.8823 61.7491 47.9061Z",
    fill: "#FF00A2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6952 38.2334C62.6708 38.2334 63.4639 37.4397 63.4639 36.4641C63.4639 35.4884 62.6702 34.6953 61.6952 34.6953C60.7189 34.6953 59.9258 35.4891 59.9258 36.4641C59.9258 37.4397 60.7189 38.2334 61.6952 38.2334Z",
    fill: "#00FF51"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6952 57.0078C60.7189 57.0078 59.9258 57.8016 59.9258 58.7766C59.9258 59.7528 60.7195 60.5459 61.6952 60.5459C62.6708 60.5459 63.4639 59.7522 63.4639 58.7766C63.4639 57.8009 62.6702 57.0078 61.6952 57.0078Z",
    fill: "#FFBD5B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0938 40.4688V43.9012",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5231 42.1862C35.2594 42.1862 34.235 41.1618 34.235 39.898V38.8562C34.235 38.3512 34.4356 37.8668 34.7925 37.5099L35.3794 36.923M18.2188 15.2949C18.2188 16.8762 19.4938 18.1574 21.075 18.1574H57.975C58.6875 18.1574 59.3312 18.4449 59.8 18.9137C60.2625 19.3762 60.55 20.0199 60.55 20.7324C60.55 22.1512 59.4 23.3074 57.975 23.3074H42.7812M39.9562 29.6012V25.8262C39.9562 25.1074 40.2562 24.4637 40.7375 24.0074",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9803 49.0505C60.6123 49.0505 61.1247 48.5381 61.1247 47.9061C61.1247 47.2741 60.6123 46.7617 59.9803 46.7617C59.3483 46.7617 58.8359 47.2741 58.8359 47.9061C58.8359 48.5381 59.3483 49.0505 59.9803 49.0505Z",
    stroke: "#AF0566",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6952 37.6091C62.3272 37.6091 62.8395 37.0967 62.8395 36.4647C62.8395 35.8327 62.3272 35.3203 61.6952 35.3203C61.0631 35.3203 60.5508 35.8327 60.5508 36.4647C60.5508 37.0967 61.0631 37.6091 61.6952 37.6091Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6952 59.9216C62.3272 59.9216 62.8395 59.4092 62.8395 58.7772C62.8395 58.1452 62.3272 57.6328 61.6952 57.6328C61.0631 57.6328 60.5508 58.1452 60.5508 58.7772C60.5508 59.4092 61.0631 59.9216 61.6952 59.9216Z",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5272 49.6755C20.5044 49.6755 21.2966 48.8833 21.2966 47.9061C21.2966 46.9289 20.5044 46.1367 19.5272 46.1367C18.55 46.1367 17.7578 46.9289 17.7578 47.9061C17.7578 48.8833 18.55 49.6755 19.5272 49.6755Z",
    fill: "#00FF51"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4584 33.4909C10.4941 33.4909 9.70969 32.7066 9.70969 31.7422C9.70969 31.3966 9.42969 31.1172 9.08469 31.1172C8.73969 31.1172 8.45969 31.3966 8.45969 31.7422C8.45969 32.7066 7.67531 33.4909 6.71094 33.4909C6.36594 33.4909 6.08594 33.7703 6.08594 34.1159C6.08594 34.4616 6.36594 34.7409 6.71094 34.7409C7.67531 34.7409 8.45969 35.5259 8.45969 36.4903C8.45969 36.8359 8.73969 37.1153 9.08469 37.1153C9.42969 37.1153 9.70969 36.8359 9.70969 36.4903C9.70969 35.5259 10.4941 34.7409 11.4584 34.7409C11.8034 34.7409 12.0834 34.4616 12.0834 34.1159C12.0834 33.7703 11.8034 33.4909 11.4584 33.4909Z",
    fill: "#006ED0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8123 38.2334C18.788 38.2334 19.5817 37.4397 19.5817 36.4641C19.5817 35.4884 18.788 34.6953 17.8123 34.6953C16.8367 34.6953 16.043 35.4891 16.043 36.4641C16.043 37.4397 16.8367 38.2334 17.8123 38.2334Z",
    fill: "#FF00A2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8123 57.0078C16.8367 57.0078 16.043 57.8016 16.043 58.7766C16.043 59.7528 16.8367 60.5459 17.8123 60.5459C18.788 60.5459 19.5817 59.7522 19.5817 58.7766C19.5817 57.8009 18.788 57.0078 17.8123 57.0078Z",
    fill: "#FFBD5B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5272 49.0505C20.1592 49.0505 20.6716 48.5381 20.6716 47.9061C20.6716 47.2741 20.1592 46.7617 19.5272 46.7617C18.8952 46.7617 18.3828 47.2741 18.3828 47.9061C18.3828 48.5381 18.8952 49.0505 19.5272 49.0505Z",
    stroke: "#068C49",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8123 37.6091C18.4444 37.6091 18.9567 37.0967 18.9567 36.4647C18.9567 35.8327 18.4444 35.3203 17.8123 35.3203C17.1803 35.3203 16.668 35.8327 16.668 36.4647C16.668 37.0967 17.1803 37.6091 17.8123 37.6091Z",
    stroke: "#AF0566",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63422 53.6805C10.9273 53.6805 11.9755 52.6323 11.9755 51.3393C11.9755 50.0463 10.9273 48.998 9.63422 48.998C8.34118 48.998 7.29297 50.0463 7.29297 51.3393C7.29297 52.6323 8.34118 53.6805 9.63422 53.6805Z",
    fill: "#FF00A2"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M54.642 71.5575C55.9351 71.5575 56.9833 70.5093 56.9833 69.2163C56.9833 67.9232 55.9351 66.875 54.642 66.875C53.349 66.875 52.3008 67.9232 52.3008 69.2163C52.3008 70.5093 53.349 71.5575 54.642 71.5575Z",
    fill: "#173EFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8123 59.9216C18.4444 59.9216 18.9567 59.4092 18.9567 58.7772C18.9567 58.1452 18.4444 57.6328 17.8123 57.6328C17.1803 57.6328 16.668 58.1452 16.668 58.7772C16.668 59.4092 17.1803 59.9216 17.8123 59.9216Z",
    stroke: "#FA7F00",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75469 35.2984C8.34844 34.5922 7.58594 34.1172 6.71094 34.1172C8.01719 34.1172 9.07969 33.0547 9.07969 31.7422C9.07969 32.5359 9.47344 33.2422 10.0734 33.6734",
    stroke: "#082FBC",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3281 53.5762V56.543",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8113 55.0586H69.8438",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M30.125 66.0762V69.043",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6114 67.5586H28.6445",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78437 53.05C9.73437 53.0562 9.68437 53.0562 9.63437 53.0562C8.69062 53.0562 7.92188 52.2875 7.92188 51.3375C7.92188 50.3875 8.69062 49.625 9.63437 49.625C10.3844 49.625 11.0156 50.1 11.2531 50.7625",
    stroke: "#AF0566",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3258 69.5375C56.3445 69.4313 56.357 69.325 56.357 69.2188C56.357 68.2688 55.5945 67.5 54.6445 67.5C53.6945 67.5 52.9258 68.2688 52.9258 69.2188C52.9258 70.025 53.482 70.7 54.2383 70.8813",
    stroke: "#1C007B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3297 16.7375C62.8509 16.7375 62.4609 16.3475 62.4609 15.8687C62.4609 15.39 62.8509 15 63.3297 15C63.8084 15 64.1984 15.39 64.1984 15.8687C64.1984 16.3475 63.8084 16.7375 63.3297 16.7375Z",
    fill: "#EE4C7B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5547 22.161L65.6991 18.7285",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9336 25.9724L71.4717 25.2168",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2734 23.8773L72.5666 18.7285",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1444 22.161L13 18.7285",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7647 25.9724L7.22656 25.2168",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4298 23.8773L6.13672 18.7285",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M68.75 41.875L71.25 40L72.5 41.25L75.625 38.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 41.875L8.75 40L7.5 41.25L4.375 38.75",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 11.25L33.125 14.375",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 11.25L46.875 14.375",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14.3008V6.80078",
    stroke: "#006ED0",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue1);
export default __webpack_public_path__ + "static/media/issue-1.2a126422eedb0dbef1f60900a50c03d8.svg";
export { ForwardRef as ReactComponent };